import { env } from 'src/config/env'

export const enableMocking = async () => {
  if (env.MODE === 'test') {
    const { worker } = await import('./browser')
    const { initializeDb } = await import('./db')
    await initializeDb()
    return worker.start()
  }
  return Promise.resolve()
}
